<div class="out" #outComponent [ngClass]="{drawing:!bPanning}">
  <div class="content">
    <div class="left" *ngIf="!bAskForFile && !bReadyToRecordTask ">
      <div class="kvideos" *ngIf="call_id">

        <k-video role="caller" [no_prompts]="true" [show_canvas]="false" screen="in-call-asset" [small]="true" class="kvideo kvideo_l" [bMirrow]="true">
        </k-video>

        <k-video role="rep" [no_prompts]="true" [show_canvas]="false" screen="in-call-asset" [small]="true" class="kvideo">
        </k-video>

      </div>
      <div class="step" [style.background]="color">
        {{task_name}}
        <img *ngIf="bShowRecUI" src="assets/images/delete.svg" class="delete" (click)="delTask()">
      </div>
      <sketches *ngIf="bShowRecUI" class="sketches" [ngClass]="{sketches_c:call_id}"></sketches>
      <overview (hide)="hideOverview()" class="overview"></overview>
    </div>


    <div class="right" *ngIf="!bAskForFile">
      <div class="video cont" [style.width.px]="video_cont_w" [style.height.px]="video_cont_h" [style.left.px]="video_cont_l" [style.top.px]="video_cont_t">
        <video class="video video_back" [muted]="true" #play_video playsinline [style.width.px]="video_w" [style.height.px]="video_h" [style.left.px]="video_l" [style.top.px]="video_t">
        </video>
        <k-spinner *ngIf="bShowSpinner" class="abs_center" spinner="assets/images/spin_white.svg" [size]="200"></k-spinner>
        <div *ngIf="!bAskForFile && bPanning" class="play">
          <img *ngIf="!bReadyToRecordTask && !bReadyToRecordTeacher && !bPlaying" class="fl h20" src="assets/images/play12x12.svg" alt="" (click)="play()">
          <img *ngIf="!bReadyToRecordTask && !bReadyToRecordTeacher && bPlaying" class="fl h20" src="assets/images/pause_b.svg" alt="" (click)="pause()">
          <img class="fl h20" *ngIf="!bOtherRec  && (bReadyToRecordTeacher || bReadyToRecordTask) && rec_status=='ready' || rec_status=='starting'" src="assets/images/rec.svg" alt="" kzLib (click)="rec()">
          <img class="fl h20" *ngIf="bOtherRec ||((bReadyToRecordTeacher || bReadyToRecordTask) && rec_status=='recording')" src="assets/images/stop.svg" alt="" kzLib (click)="stop()">
          <span *ngIf="bReadyToRecordTask">Duration: {{duration}}</span>
          <div *ngIf="!bReadyToRecordTask" class="bar" [ngClass]="{bar_intro:!bReadyToRecordTeacher}" (click)="seekBar($event)">
            <div class="bar progress" [style.width.%]="progress">
            </div>
          </div>
          <div *ngIf="!bReadyToRecordTask" class="curr_time">{{scene_time | number:'1.2-2'}} / {{scene_duration | number:'1.2-2'}}</div>
        </div>
        <div *ngIf="bReadyToZoomPanDraw" class="zoom_pan">
          <img *ngIf="!bPlaying" class="fl zm" src="assets/images/zoom_in.svg" (click)="zoomIn()" alt="">
          <img *ngIf="!bPlaying" class="fl zm" src="assets/images/zoom_out.svg" (click)="zoomOut()" alt="">
          <img *ngIf="!bPlaying && bPanning" class="fl zm" src="assets/images/pencil.svg" (click)="draw()" alt="">
          <img *ngIf="!bPlaying && !bPanning" class="fl zm" src="assets/images/pencil_on.svg" (click)="draw()" alt="">
          <img *ngIf="!bPlaying && bPanning && zoom > 1 " class="fl zm" src="assets/images/pan.svg" alt="">
        </div>
      </div>


      <div *ngIf="act!='intro'" class="teacher_video" [ngClass]="{teacher_rec:bReadyToRecordTeacher}">
        <video #teacherVideoElement class="rec_video" playsinline [ngClass]="{rec:rec_status=='recording', hidden:bReadyToRecordTeacher}">
        </video>
        <video #recTeacher class="rec_video" playsinline [ngClass]="{rec:rec_status=='recording', hidden:!bReadyToRecordTeacher}">
        </video>
      </div>

      <div class="video canvas" #canvas [style.width.px]="video_cont_w" [style.height.px]="video_cont_h" [style.left.px]="video_cont_l" [style.top.px]="video_cont_t">
      </div>





      <div *ngIf="bReadyToRecordTask" class="step rec_inst" [style.background]="color">
        Record {{task_name}}
        <img *ngIf="bShowRecUI" src="assets/images/delete.svg" class="delete" (click)="delTask()">
      </div>

      <div class="tabs" *ngIf="!bReadyToRecordTask">
        <div class="tab tab_s intro_d" [ngClass]="{intro:act=='intro'}" (click)="playScene('intro', scene_index)">
          <div class="abs_center ">
            Overview
          </div>
        </div>
        <div class="tab describe_d" [ngClass]="{describe:act=='describe'}" (click)="playScene('describe', scene_index)">
          <div class="abs_center">
            Detail
          </div>
        </div>
        <div class="tab tab_r problems_d" [ngClass]="{problems:act=='problems'}" (click)="playScene('problems', scene_index)">
          <div class="abs_center ">
            Critical
          </div>
        </div>
      </div>

      <div *ngIf="bShowRecUI && !bReadyToRecordTask" class="steps">
        <segments [curr_time]="curr_time" (seek)="seekSeg($event)"></segments>
      </div>

    </div>

    <div class="abs_center ctr_bx" *ngIf="bAskForFile && !rem_rec">
      <div class="vtf">
        <div class="vt mt40">
          <div class="btn no_v_btns mt0 ts" (click)="startVideoTask()">
            <div class="abs_center intro_d">
              Task: {{task_name}}
            </div>
            <img src="assets/images/delete.svg" class="delete" (click)="delTask()">
          </div>
        </div>
        <div *ngIf="bShowRecUI" ng2FileDrop (onFileDrop)="dropped($event)" class="vt mt40">
          <div class="btn no_v_btns mt0" (click)="file.click()">
            <div class="abs_center">
              Select file
            </div>
          </div>
        </div>
        <input #file class="hidden" type="file" (change)="uploadFile($event)" accept="video/*">

        <div class="vt mt40">
          Drop a File
        </div>
        <div class="vtf">
          <div class="vt mt40" (click)="startVideoTask()">
            <div class="btn no_v_btns mt0">
              <div class="abs_center">
                Use Camera
              </div>
            </div>
          </div>
        </div>
        <div class="video">
          <div class="abs_center">
            Work in progress ...
          </div>
        </div>
      </div>

      <k-spinner *ngIf="bShowSpinner" class="abs_center" [size]="200"></k-spinner>

    </div>

    <div *ngIf="rem_rec" class="remote_int">
      <video class="video video_back" [muted]="false" #play_video playsinline [style.width.px]="video_w" [style.height.px]="video_h" [style.left.px]="video_l" [style.top.px]="video_t">
      </video>
      <div class="vt">
        Remote Task rec_status:{{rec_status}}
        <img class="fl h20" *ngIf="rec_status=='ready' || rec_status=='starting'" src="assets/images/rec.svg" alt="" kzLib (click)="recRemTask()">
        <img class="fl h20" *ngIf="rec_status=='recording'" src="assets/images/stop.svg" alt="" kzLib (click)="stopRemTask()">
        <k-button class="settings" icon="flip.svg" background="#ECECEC" (click)="flipRemTask()"></k-button>
        <span *ngIf="bReadyToRecordTask"> Duration: {{duration}}</span>
      </div>

    </div>
  </div>
  <div *ngIf="!isPhone" class="back" (click)="goBack()">
    Back
  </div>
</div>
